/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneContentLock as ResolvedStandaloneContentLock } from 'base/components/standalone/ContentLock';

export const ContentLock: typeof ResolvedStandaloneContentLock = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneContentLock {...props} />
        </ErrorBoundary>
    );
});

export type ContentLockProps = PropsFromComponent<typeof ContentLock>;

/** @deprecated Use slot architecture instead */
export const ContentLockWith = (extras: DynamicStandaloneExtras): typeof ContentLock => {
    return function ContentLock(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ContentLock');
        return <ResolvedStandaloneContentLock {...mergeProps({ options: { theme } }, props)} />;
    }
}